import React from 'react';
import 'react-responsive-modal/styles.css';
import {Modal} from 'react-responsive-modal';
import {AppEnv} from '../../../env';
import {Col, Row} from 'react-material-responsive-grid';
import axios from 'axios';
import ModalSteps from '../Admisiones/ModalSteps';
import {confirmAlert} from 'react-confirm-alert';
import FaltaMensaje from '../../../Global-W/Classes/FaltaMensaje';
import {connect} from "react-redux";
import {setInitValues} from "../../../../redux/actions";
import {
    alertFail,
    alertWarning,
    currency,
    customAlert,
    customAlertResp,
    pulseLoader,
    whatsAppMessage
} from "../../../Global-W/NewFunctions";
import PasswordCheck from "../../../Global-W/Hooks/PasswordCheck";


const moment = require('moment');
require('moment/locale/es');
moment.locale('es');

class AspirantesTutor extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            idTutor: sessionStorage.getItem('idTutor'),
            bd: sessionStorage.getItem('bd'),
            validationAlta: false,
            elAspirante: [],
            aspirantes: [],
            id_tutor: '',
            stepsLabel: [],
            visible: false,
            modalAspirante: [],
            elComentario: '',
            idAlumno: '',
            indicator: false,
            pasosPreinscrip: [],
            stepIndicator: [],
            elComprobante: [{url_doc: ''}],
            elComprobante2: [{url_doc: ''}],
            modalSteps: false,
            elPaso: [],
            data1: [],
            data2: [],
            globals: [],
            modalPago: false,
            documento: false,
            aspirante: [],
            selItem: [],
            elPdf: '',
            op: '',
            production: false,
            modalNewAsp: false,
            openPdf: false,
            modalPassword: false,
            password: '',
            password2: '',
            chargeLogin: false,
            soporteKolegiaCheck: false,
            soporteEscuelaCheck: false,
            indicatorButton: false,
            sizeModal: '',
            isLoading: false,
            message: 'En este momento no hay lugares disponibles, sin embargo, una vez terminado el proceso de admisión, el aspirante entrará en lista de espera debido a que ya no hay espacio disponible en el grado deseado.'
        };
        this.config = {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        };
    }


    _spinner = (state) => {
        this.setState({visible: state});
    };

    async componentDidMount() {
        await this.getAspirantes(this.state.idTutor);
        await this.getComprobante();
    }

//-+-+-+-+-++---+-+-+-+-+get aspirantes
    async getAspirantes(id) {
        try {
            await this.setState({indicator: true});
            const {data} = await axios.get(AppEnv.apiGes + 'get/aspirante/' + id);
            if (data.length !== 0) {
                this.setState({aspirantes: data});
                let curPosittion = [];
                let modal = [];
                data.forEach(() => {
                    curPosittion.push(0);
                    modal.push(false);
                });
                this.setState({stepIndicator: curPosittion, modalAspirante: modal});
                this.getPasosPreinscrip(data);
                this.setState({indicator: false});
            }
        } catch (e) {

        }

    }

    async checkAltaData(aspirante, ix) {
        this.setState({isLoading: true})
        await fetch(AppEnv.apiGes + 'get/aspirante/' + this.state.idTutor).then(res => res.json())
            .then(async responseJson => {
                if (responseJson.error === undefined) {
                    let foundAlta = true;
                    for (let i = 0; i < responseJson.length; i++) {
                        if (responseJson[i].estatus_alta === 'casi alta') {
                            foundAlta = false;
                        }
                    }
                    this.setState({elAspirante: aspirante, validationAlta: foundAlta});
                    confirmAlert({
                        customUI: ({onClose}) => {
                            return customAlertResp('¡FELICIDADES!',
                                'Ahora es parte de nuestra comunidad escolar. ' +
                                'Se enviará a su correo una contraseña con la cual podrá ingresar como usuario en la vista del menú principal.', 1,
                                'Enterado ¡Gracias!', null, null,
                                () => [this.setState({modalPassword: true}), onClose()]);
                        }
                    });
                }
            });
    }

    //VALIDATE STEP
    typeIdStep(stepAsp, aspirante) {
        if (stepAsp.id === 2) {
            return aspirante.paso_2 === '2';
        }
        if (stepAsp.id === 3) {
            return aspirante.paso_3 === '2';
        }
        if (stepAsp.id === 4) {
            return aspirante.paso_4 === '2';
        }
        if (stepAsp.id === 5) {
            return aspirante.paso_5 === '2';
        }
        if (stepAsp.id === 6) {
            return aspirante.paso_6 === '2';
        }
        if (stepAsp.id === 7) {
            return aspirante.paso_7 === '2';
        }
        if (stepAsp.id === 8) {
            return aspirante.paso_8 === '2';
        }
        return false;
    }

    // Extra config
    async getInfoExtra(it, ix) {
        await fetch(AppEnv.api + it.bd_escuela + '/config/all', {
            method: 'GET', headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + this.state.token
            }
        }).then(response => response.json())
            .then(async recurso => {
                this.setState({numberWhatsapp: recurso.number_whatsapp})
                if (recurso.school_support_status === undefined) this.setState({soporteEscuelaCheck: false})
                this.setState({soporteEscuelaCheck: recurso.school_support_status})
                if (recurso.kolegia_support_status === undefined) this.setState({soporteKolegiaCheck: false})
                this.setState({soporteKolegiaCheck: recurso.kolegia_support_status})
                await this.setState({visible: false});
                if (recurso.grados_limite_status) this.state.aspirantes[ix].grados_limite_status = recurso.grados_limite_status
                if (recurso.grados_config) this.state.aspirantes[ix].grados_config = recurso.grados_config
                if (recurso.circular_informativa === '1') {
                    this.state.aspirantes[ix].circular_informativa = recurso.circular_informativa_doc !== undefined ? recurso.circular_informativa_doc : ''
                } else {
                    this.state.aspirantes[ix].circular_informativa = '';
                }
                if (recurso.ficha_solicitud === '1') {
                    this.state.aspirantes[ix].ficha_solicitud = recurso.ficha_solicitud_doc !== undefined ? recurso.ficha_solicitud_doc : ''
                } else {
                    this.state.aspirantes[ix].ficha_solicitud = '';
                }
                if (recurso.ficha_entrevista === '1') {
                    this.state.aspirantes[ix].ficha_entrevista = recurso.ficha_entrevista_doc !== undefined ? recurso.ficha_entrevista_doc : '';
                } else {
                    this.state.aspirantes[ix].ficha_entrevista = '';
                }
                if (recurso.acuerdo_convivencia === '1') {
                    this.state.aspirantes[ix].acuerdo_convivencia = recurso.acuerdo_convivencia_doc !== undefined ? recurso.acuerdo_convivencia_doc : '';
                } else {
                    this.state.aspirantes[ix].acuerdo_convivencia = '';
                }
                if (recurso.contrato_servicio === '1') {
                    this.state.aspirantes[ix].contrato_servicio = recurso.contrato_servicio_doc !== undefined ? recurso.contrato_servicio_doc : '';
                } else {
                    this.state.aspirantes[ix].contrato_servicio = '';
                }
                if (recurso.aviso_privacidad === '1') {
                    this.state.aspirantes[ix].aviso_privacidad = recurso.aviso_privacidad_doc !== undefined ? recurso.aviso_privacidad_doc : '';
                } else {
                    this.state.aspirantes[ix].aviso_privacidad = '';
                }
                if (recurso.carta_compromiso === '1') {
                    this.state.aspirantes[ix].carta_compromiso = recurso.carta_compromiso_doc !== undefined ? recurso.carta_compromiso_doc : '';
                } else {
                    this.state.aspirantes[ix].carta_compromiso = '';
                }
                if (recurso.otro_solicitud === '1') {
                    this.state.aspirantes[ix].otro_solicitud = recurso.otro_solicitud_doc !== undefined ? recurso.otro_solicitud_doc : '';
                } else {
                    this.state.aspirantes[ix].otro_solicitud = '';
                }
            });
    }

    fetchStatistics = async (alumno, i) => {
        try {
            const response = await axios.get(AppEnv.api + alumno.bd_escuela + '/get/ciclo/siguiente')
            const {data} = await axios.get(AppEnv.api + alumno.bd_escuela + '/get/aspirantes/alta/' + response.data.id + '/' + alumno.grado_interes)
            this.state.aspirantes[i].escuelaAspirantes = data
            return data
        } catch (error) {
            console.error('error -> ', error)
        }
    }

    async getPasosPreinscrip(aspirantes) {
        for (let i = 0; i < aspirantes.length; i++) {
            await this.getInfoExtra(aspirantes[i], i);
            let array = [];
            let aspirante = aspirantes[i];
            await this.fetchStatistics(aspirante, i)
            await fetch(AppEnv.api + aspirante.bd_escuela + '/get/pasos/preinscrip', {
                method: 'GET', headers: {'Content-Type': 'application/json'}
            }).then(res => res.json())
                .then(responseJson => {
                    if (responseJson.length !== 0) {
                        if (responseJson[0].estatus === '1') {
                            array.push(responseJson[0]);
                            this.state.stepIndicator[i] = array.length;
                        }
                        if (responseJson[1].estatus === '1') {
                            array.push(responseJson[1]);
                            if (this.state.stepIndicator[i] < array.length && this.state.stepIndicator[i] >= array.length - 1) {
                                if (this.typeIdStep(responseJson[1], aspirante) === true) {
                                    this.state.stepIndicator[i] = array.length;
                                }
                            }
                        }
                        if (responseJson[2].estatus === '1') {
                            array.push(responseJson[2]);
                            if (this.state.stepIndicator[i] < array.length && this.state.stepIndicator[i] >= array.length - 1) {
                                if (this.typeIdStep(responseJson[2], aspirante) === true) {
                                    this.state.stepIndicator[i] = array.length;
                                }
                            }
                        }
                        if (responseJson[3].estatus === '1') {
                            array.push(responseJson[3]);
                            if (this.state.stepIndicator[i] < array.length && this.state.stepIndicator[i] >= array.length - 1) {
                                if (this.typeIdStep(responseJson[3], aspirante) === true) {
                                    this.state.stepIndicator[i] = array.length;
                                }
                            }
                        }
                        if (responseJson[4].estatus === '1') {
                            array.push(responseJson[4]);
                            if (this.state.stepIndicator[i] < array.length && this.state.stepIndicator[i] >= array.length - 1) {
                                if (this.typeIdStep(responseJson[4], aspirante) === true) {
                                    this.state.stepIndicator[i] = array.length;
                                }
                            }
                        }
                        if (responseJson[5].estatus === '1') {
                            array.push(responseJson[5]);
                            if (this.state.stepIndicator[i] < array.length && this.state.stepIndicator[i] >= array.length - 1) {
                                if (this.typeIdStep(responseJson[5], aspirante) === true) {
                                    this.state.stepIndicator[i] = array.length;
                                }
                            }
                        }
                        if (responseJson[6].estatus === '1') {
                            array.push(responseJson[6]);
                            if (this.state.stepIndicator[i] < array.length && this.state.stepIndicator[i] >= array.length - 1) {
                                if (this.typeIdStep(responseJson[6], aspirante) === true) {
                                    this.state.stepIndicator[i] = array.length;
                                }
                            }
                        }
                        if (responseJson[7].estatus === '1') {
                            array.push(responseJson[7]);
                            if (this.state.stepIndicator[i] < array.length && this.state.stepIndicator[i] >= array.length - 1) {
                                if (this.typeIdStep(responseJson[7], aspirante) === true) {
                                    this.state.stepIndicator[i] = array.length;
                                }
                            }
                        }
                    }
                });
            await this.setState({aux: 0});
        }
        await this.setState({indicator: false});
    }

    async getComprobante() {
        let aspirante = this.state.aspirantes[0];
        let tipos = ['preinscripcion', 'inscripcion'];
        for (let i = 0; i < tipos.length; i++) {
            await fetch(AppEnv.api + aspirante.bd_escuela + '/preinscripcion/comprobante/pago/' + aspirante.id_tutor + '/' + aspirante.id + '/comprobante pago_' + tipos[i]).then(res => res.json())
                .then(resJson => {
                    if (resJson.error === undefined) {
                        if (tipos[i] === 'preinscripcion') {
                            this.setState({elComprobante: resJson});
                        }
                        if (tipos[i] === 'inscripcion') {
                            this.setState({elComprobante2: resJson});
                        }
                    }
                });
        }
    }

    // <=<●>=><=<●>=><=<●>=> Enviar indicacion <=<●>=><=<●>=><=<●>=>
    async enviarIndicacion(id, indicacion, i) {
        if (this.state.elComentario === '') {
            alertWarning('Escriba las indicaciones para poder continuar, de lo contrario presione cancelar');
        } else {
            await fetch(AppEnv.apiGes + 'indicacion/especial/' + id + '/' + indicacion).then(res => res)
                .then(responseJson => {
                    if (responseJson.error !== undefined) {
                        alertFail();
                        this.closeModal(i);
                    } else {
                        this.closeModal(indicacion, i);
                    }
                });
        }
    }

    async openModal(aspirante, i) {
        this.state.modalAspirante[i] = true;
        this.state.elComentario = aspirante.indicacion_especial;
        this.state.idAlumno = aspirante.id;
        await this.setState({aux: 0});
    }

    async closeModal(indicacion, i) {
        this.state.aspirantes[i].indicacion_especial = indicacion;
        this.state.modalAspirante[i] = false;
        await this.setState({aux: 0});
    }

    // <=<●>=><=<●>=><=<●>=> Revisar pagos<=<●>=><=<●>=><=<●>=>

    async getDatos(aspirante) {
        await fetch(AppEnv.apiGes + 'escuela/datos/' + aspirante.bd_escuela, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + this.state.token
            }
        })
            .then(response => {
                return response.json();
            })
            .then(responseJson => {
                if (responseJson.error !== undefined) {
                    alertFail()
                } else {
                    if (responseJson[0].orden === '1') {
                        this.setState({
                            op: AppEnv.OpenPay,
                            opk: AppEnv.OpenPayPK,
                            production: AppEnv.Production
                        });
                    } else if (responseJson[0].orden === '2') {
                        this.setState({
                            op: AppEnv.OpenPayI,
                            opk: AppEnv.OpenPayPKI,
                            production: AppEnv.ProductionI
                        });
                    } else if (responseJson[0].orden === '3') {
                        this.setState({
                            op: AppEnv.OpenPayII,
                            opk: AppEnv.OpenPayPKII,
                            production: AppEnv.ProductionII
                        });
                    } else if (responseJson[0].orden === '4') {
                        this.setState({
                            op: AppEnv.OpenPayIII,
                            opk: AppEnv.OpenPayPKIII,
                            production: AppEnv.ProductionIII
                        });
                    } else if (responseJson[0].orden === '5') {
                        this.setState({
                            op: AppEnv.OpenPayIV,
                            opk: AppEnv.OpenPayPKIV,
                            production: AppEnv.ProductionIV
                        });
                    } else if (responseJson[0].orden === '6') {
                        this.setState({
                            op: AppEnv.OpenPayV,
                            opk: AppEnv.OpenPayPKV,
                            production: AppEnv.ProductionV
                        });
                    }
                }
            });
    }

    async modalPay(aspirante, ix, dataPay) {
        await this.getDatos(aspirante);
        await this.setState({
            modalPago: true,
            selItem: dataPay.result.serializableData,
            aspirante: aspirante,
            elPdf: dataPay.result.id
        });
    }

    async revisarPago(aspirante, tipo_pago, ix) {
        await this._spinner(true);
        //GET DATA CHARGE
        let cargo = [];
        await fetch(AppEnv.api + aspirante.bd_escuela + '/preinscripcion/data/payment/' + tipo_pago, {
            method: 'GET', headers: {
                Accept: 'application/json, text/plain, */*',
                'Content-Type': 'application/json'
            }
        }).then(res => {
            return res.json();
        }).then(resJson => resJson.error === undefined ? cargo = resJson : null);
        await fetch(AppEnv.api + aspirante.bd_escuela + '/estatus/pago/curso/' + aspirante.id + '/' + cargo.id, {
            method: 'GET', headers: {
                'Content-Type': 'application/json'
            }
        }).then(res => res.json())
            .then(responseJson => {
                if (responseJson.error !== undefined) {
                    alertFail();
                    this._spinner(true);
                } else {
                    if (responseJson.status === 'En progreso') {
                        alertWarning('Su pago está en proceso de ser validado por el administrador, se le notificará cuando pueda continuar con el proceso de inscripción');
                        this._spinner(false);
                    } else if (responseJson.status === 'Completado') {
                        if (this.state.stepIndicator[ix] === aspirante.labelStep.length) {
                            confirmAlert({
                                customUI: ({onClose}) => {
                                    return customAlertResp('Su pago ha sido acreditado',
                                        'Ahora podrá continuar con el proceso de inscripción', 1,
                                        'Entendido', null, null,
                                        () => [this._spinner(false), this.updateTransaction(aspirante, 'alta', tipo_pago, ix, cargo), onClose()]);
                                }
                            });
                        } else {
                            confirmAlert({
                                customUI: ({onClose}) => {
                                    return customAlertResp('Su pago ha sido acreditado',
                                        'Ahora podrá continuar con el proceso de inscripción', 1,
                                        'Entendido', null, null,
                                        () => [this._spinner(false), this.updateTransaction(aspirante, 'en proceso', tipo_pago, ix, cargo), onClose()]);
                                }
                            });
                        }
                    }
                    if (responseJson.result.status === '0') {
                        alertFail();
                        this._spinner(false);
                    } else if (responseJson.result.status === 'in_progress' || responseJson.result.status === 'charge_pending') {
                        this.modalPay(aspirante, ix, responseJson);
                        this._spinner(false);
                    } else if (responseJson.result.status === 'completed') {
                        if (this.state.stepIndicator[ix] === aspirante.labelStep.length) {
                            confirmAlert({
                                customUI: ({onClose}) => {
                                    return customAlertResp('Su pago ha sido acreditado',
                                        'Ahora podrá continuar con el proceso de inscripción', 1,
                                        'Entendido', null, null,
                                        () => [this._spinner(false), this.updateTransaction(aspirante, 'alta', tipo_pago, ix, cargo), onClose()]);
                                }
                            });
                        } else {
                            confirmAlert({
                                customUI: ({onClose}) => {
                                    return customAlertResp('Su pago ha sido acreditado',
                                        'Ahora podrá continuar con el proceso de inscripción', 1,
                                        'Entendido', null, null,
                                        () => [this._spinner(false), this.updateTransaction(aspirante, 'en proceso', tipo_pago, ix, cargo), onClose()]);
                                }
                            });
                        }
                    }
                }
            });
    }

    async updateTransaction(aspirante, estatus, tipo_paso, ix, cargo) {
        let formData = new FormData();
        formData.append('update', JSON.stringify({
            hijo_id: aspirante.id,
            cargo_id: cargo.id
        }));
        await axios.post(AppEnv.api + aspirante.bd_escuela + '/preinscripcion/update/cargo/aspirante', formData, {
            method: 'POST', headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data'
            }
        }).then(responseJson => {
            if (responseJson.error !== undefined) {

            } else {
                this.updateAspirante(aspirante, estatus, tipo_paso, ix);
            }
        });
    }

    async updateAspiranteEspera(aspirante, ix) {
        if (aspirante.estatus_alta !== 'espera') {
            let formData = new FormData()
            let fD2 = new FormData()
            formData.append('update', JSON.stringify({
                id: aspirante.id,
                estatus_alta: 'espera'
            }))
            fD2.append('update', JSON.stringify({
                id_registro: aspirante.id, estatus_alta: 'espera'
            }))
            try {
                await axios.post(AppEnv.apiGes + 'update/aspirante/preinscripcion', formData, {
                    method: 'POST',
                    headers: {Accept: 'application/json', 'Content-Type': 'multipart/form-data'}
                })
                await axios.post(AppEnv.api + aspirante.bd_escuela + '/update/aspirante/school', fD2, {
                    method: 'POST',
                    headers: {Accept: 'application/json', 'Content-Type': 'multipart/form-data'}
                })
                return true
            } catch (error) {
                return false
            } finally {
                this.setState({isLoading: false})
            }
        }
        return false
    }

    async updateAspirante(aspirante, estatus, tipo_paso, ix) {
        let formData = new FormData();
        if (tipo_paso === 'preinscripcion') {
            formData.append('update', JSON.stringify({
                id: aspirante.id,
                paso_4: 2,
                estatus_alta: estatus
            }));
        } else if (tipo_paso === 'inscripcion') {
            formData.append('update', JSON.stringify({
                id: aspirante.id,
                paso_8: 2,
                estatus_alta: estatus
            }));
        } else if (tipo_paso === 'ultimo paso') {
            formData.append('update', JSON.stringify({
                id: aspirante.id,
                paso_registro: aspirante.pasos_preinscrip.length,
                estatus_alta: 'alta'
            }));
        } else if (tipo_paso === 'espera') {
            formData.append('update', JSON.stringify({
                id: aspirante.id,
                paso_registro: aspirante.pasos_preinscrip.length,
                estatus_alta: 'alta'
            }));
            return true
        }
        await axios.post(AppEnv.apiGes + 'update/aspirante/preinscripcion', formData, {
            method: 'POST', headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data'
            }
        }).then(async responseJson => {
            if (responseJson.error !== undefined) {
                alertFail();
                this._spinner(false);
            } else {
                await this.setState({elAspirante: aspirante});
                if (estatus === 'alta') {

                } else {
                    this.getAspirantes(aspirante.id_tutor);
                }
            }
        });
    }

    async validationDatos(pass) {
        await this.setState({password: pass})
        if (this.state.password === '') {
            alertWarning('Contraseña vacía. Debe capturar una contraseña');
        } else {
            await this.setState({chargeLogin: true});
            this.state.elAspirante.tutor.password = pass;
            if (this.state.validationAlta) {
                await this.updateTutor(this.state.elAspirante, 'alta')
            } else {
                await this.updateTutor2(this.state.elAspirante, 'alta');
                await this.passUpdate(this.state.elAspirante);
                await this.passUpdate(this.state.elAspirante);
            }
        }
    }

    async _fetchLoginData(mail, pass) {
        await this.setState({loading: true});
        await fetch(AppEnv.api + this.state.elAspirante.bd_escuela + '/auth/login', {
                method: 'post', headers: {
                    Accept: 'application/json, text/plain, */*', 'Content-Type': 'application/json'
                }, body: JSON.stringify({
                    email: mail, password: pass
                })
            }
        ).then(res => res.json())
            .then(responseJson => {
                if (responseJson.token === undefined) {
                    this.setState({loading: false});
                    alertWarning('Usuario o contraseña incorrectos', 'Si el error persiste solicite ayuda.');
                } else {
                    this.saveItem('token', responseJson.token);
                    if (responseJson.data.passwordUpdated === '0') {
                        this.saveItem('email', mail);
                        this.saveItem('bd', this.state.elAspirante.bd_escuela);
                        this.saveItem('nameCiclo', 'ciclo');
                        this.props.history('/change/password');
                    } else {
                        let data = {
                            bd: this.state.elAspirante.bd_escuela,
                            country: this.state.elAspirante.escuela.id_pais,
                            email: responseJson.email,
                            grado: responseJson.grado,
                            grupo: responseJson.grupo,
                            id: responseJson.id,
                            name: responseJson.name,
                            puesto: responseJson.puesto,
                            role: responseJson.role,
                            roles: JSON.stringify(responseJson.roles),
                            schoolId: this.state.elAspirante.escuela.id,
                            terminos_condiciones: responseJson.data.terminos_condiciones,
                            token: responseJson.token,
                            userPicture: responseJson.photo,
                            userRoleAlias: responseJson.alias === null ? '' : responseJson.alias,
                            activo: responseJson.activo,
                            estatus: responseJson.estatus,
                        }
                        this.props.setInitValues(data)
                        this.saveItem('role', responseJson.role);
                        this.saveItem('roles', JSON.stringify(responseJson.roles));
                        this.saveItem('id', responseJson.id);
                        this.saveItem('puesto', responseJson.puesto);
                        this.saveItem('userRoleAlias', responseJson.alias === null ? '' : responseJson.alias);
                        this.saveItem('schoolId', this.state.elAspirante.escuela.id);
                        this.saveItem('grado', responseJson.grado);
                        this.saveItem('grupo', responseJson.grupo);
                        this.saveItem('token', responseJson.token);
                        this.saveItem('name', responseJson.name);
                        this.saveItem('email', responseJson.email);
                        this.saveItem('apellido_materno', this.state.globals.apellido_materno);
                        this.saveItem('id_pais', this.state.elAspirante.escuela.id_pais);
                        this.saveItem('id_ciudadano', this.state.globals.id_ciudadano);
                        this.saveItem('alias_id_ciudadano', this.state.globals.alias_id_ciudadano);
                        this.saveItem('alias_colonia', this.state.globals.alias_colonia);
                        this.saveItem('alias_ciudad', this.state.globals.alias_ciudad);
                        this.saveItem('alias_estado', this.state.globals.alias_estado);
                        this.saveItem('estado', this.state.globals.estado);
                        this.saveItem('codigo_postal', this.state.globals.codigo_postal);
                        this.saveItem('bd', this.state.elAspirante.bd_escuela);
                        this.saveItem('terminos_condiciones', responseJson.data.terminos_condiciones);
                        this.saveItem('userPicture', responseJson.alias === null ? '' : responseJson.photo);
                        this.props.history('/dashboard');
                    }
                }
            });
    };

    async saveItem(key, item) {
        if (item !== undefined && item !== null) {
            await sessionStorage.setItem(key, item.toString());
        } else {
            await sessionStorage.setItem(key, '');
        }
    }

    async passUpdate(aspirante) {
        const formData = new FormData();
        formData.append('new', JSON.stringify({email: aspirante.tutor.email, password: this.state.password}));
        await axios.post(AppEnv.api + aspirante.bd_escuela + '/change/password/user/three', formData, {
            method: 'POST', headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            }
        }).then(resJson => {
            if (resJson.error === undefined) {
                this.updateAspirante(aspirante, 'alta', 'ultimo paso', 0);
                this._fetchLoginData(aspirante.tutor.email, this.state.password);
            }
        });
    }

    async updateTutor(aspirante, estatus) {
        let formData = new FormData();
        formData.append('update', JSON.stringify({
            id: aspirante.id_tutor,
            estatus: estatus
        }));
        await axios.post(AppEnv.apiGes + 'post/update/tutor', formData, {
            method: 'POST', headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data'
            }
        }).then(async responseJson => {
            if (responseJson.error !== undefined) {
                alertFail();
                this._spinner(false);
            } else {
                await this.createPadre(aspirante);
            }
        });
    }

    async updateTutor2(aspirante, estatus) {
        let formData = new FormData();
        formData.append('update', JSON.stringify({
            id: aspirante.id_tutor,
            estatus: estatus
        }));
        await axios.post(AppEnv.apiGes + 'post/update/tutor', formData, {
            method: 'POST', headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data'
            }
        }).then(res => {

        });
    }

    async createPadre(aspirante) {
        await this._spinner(true);
        let elAspirante = aspirante;
        delete elAspirante.pasos_preinscrip_web2;
        let formData = new FormData();
        formData.append('new', JSON.stringify({
            tutor: elAspirante.tutor,
            aspirante: elAspirante
        }));
        await axios.post(AppEnv.api + aspirante.bd_escuela + '/generate/aspirante/and/tutor/' + aspirante.id_escuela_destino, formData, {
            method: 'POST', headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data'
            }
        }).then(async responseJson => {
            if (responseJson.error !== undefined) {
                alertFail();
            } else {
                this._spinner(false);
                let fD2 = new FormData();
                fD2.append('update', JSON.stringify({
                    id_registro: aspirante.id, estatus_alta: 'alta', user_id: responseJson.data.id
                }));
                await axios.post(AppEnv.api + aspirante.bd_escuela + '/update/aspirante/school', fD2, {
                    method: 'POST', headers: {
                        Accept: 'application/json',
                        'Content-Type': 'multipart/form-data'
                    }
                });
                await this.notificarAdmin(aspirante);
                await this.passUpdate(this.state.elAspirante);
            }
        });
    }

    async notificarAdmin(aspirante) {
        let titulo = 'Nuevo usuario registrado';
        let mensaje = 'El Tutor ' + aspirante.tutor.nombre + ' de ' + aspirante.nombre_aspirante + ' se ha dado de alta en el colegio';
        let formData = new FormData();
        formData.append('notification', JSON.stringify({titulo: titulo, mensaje: mensaje, tipo: 'inscripcion'}));
        await axios.post(AppEnv.api + aspirante.bd_escuela + '/notificar/admins', formData, {
            method: 'POST', headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data'
            }
        }).then(() => {
        });
    }

    async modalStepFunc(paso, data1, data2, size) {
        await this.setState({modalSteps: true, elPaso: paso, data1: data1, data2: data2, sizeModal: size});
    }

    checkPayExist = (aspirante, i) => {
        try {
            return new Promise(async (resolve, reject) => {
                const {data} = await axios.get(AppEnv.api + aspirante.bd_escuela + '/preinscripcion/params/reinscripcion/V2/' + aspirante.pasos_preinscrip[i].key, this.config);
                resolve(data);
            })
        } catch (e) {

        }
    };

    checkPaymentResult(aspirante, i) {
        //GET DATA CHARGE
        try {
            let tipo_pago = aspirante.pasos_preinscrip[i].key;
            return new Promise(async (resolve) => {
                const response = await axios.get(AppEnv.api + aspirante.bd_escuela + '/preinscripcion/data/payment/' + tipo_pago, this.config);
                const {data} = await axios.get(AppEnv.api + aspirante.bd_escuela + '/estatus/pago/curso/' + aspirante.id + '/' + response.data.id, this.config);
                resolve(data);
            })
        } catch (e) {

        }
    }

    async fetchCountries(globals) {
        globals.forEach(it => (
            this.state.globals[it.option] = it.value
        ));
    };

    foundStep(step, aspirante) {
        try {
            return new Promise(async (resolve) => {
                const {data} = await axios.get(AppEnv.api + aspirante.bd_escuela + '/get/type/date/' + step.key, this.config);
                resolve(data[0].option_key);
            });
        } catch (e) {

        }
    }

    alertDefinido(step, aspirante) {
        let message = <Row className="uk-width-1-1 centerAll">
            <label className="uk-width-1-1" style={{textAlign: 'center'}}>
                El administrador del colegio definirá la fecha para <b
                style={{textTransform: 'uppercase'}}>{step.alias}</b>. Se le notificará por aquí al fecha y
                recibirá un correo de confirmación.
            </label>
        </Row>;
        confirmAlert({
            customUI: ({onClose}) => {
                return customAlert('En espera',
                    message, 1,
                    'Enterado, gracias', null, null,
                    () => {
                        onClose()
                    }, null);
            }
        });
    }

    saveDateAspIED(aspirante, key) {
        try {
            return new Promise(async resolve => {
                const {data} = await axios.get(AppEnv.api + aspirante.bd_escuela + '/date/saved/aspirante/' + aspirante.id_tutor + '/' + aspirante.id + '/' + key);
                resolve(data);
            })
        } catch (e) {

        }
    }

    fetchInscritos = async (bd, ciclo) => {
        try {
            const {data} = await axios.get(AppEnv.api + bd + '/get/aspirantes/alta/espera/' + ciclo)
            return data
        } catch (error) {
            console.error(error)
            return null
        }
    }

    async pasoSiguiente(aspirante, ix) {
        await this.fetchCountries(aspirante.escuela.globals)
        let stepsLabel = aspirante.pasos_preinscrip;
        let i = this.state.stepIndicator[ix];
        if (i === stepsLabel.length) {
            if (aspirante.grados_config) {
                if (aspirante.grados_limite_status === '1' && aspirante.grados_config) {
                    this.setState({isLoading: true})
                    const inscritos = await this.fetchInscritos(aspirante.bd_escuela, aspirante.id_ciclo)
                    const result = (Number(Object.entries(JSON.parse(aspirante.grados_config)).filter(grado => grado[0] === aspirante.grado_interes)[0][1]) - Number(inscritos.filter(inscrito => inscrito.grado_interes === aspirante.grado_interes).length))
                    if (result === 0) {
                        confirmAlert({
                            customUI: ({onClose}) => {
                                return customAlert('En espera',
                                    this.state.message, 1,
                                    'Enterado, gracias', null, null,
                                    async () => {
                                        await this.updateAspiranteEspera(aspirante, ix)
                                        onClose()
                                    }, null);
                            }
                        })
                    } else {
                        await this.checkAltaData(aspirante, ix);
                    }
                } else {
                    await this.checkAltaData(aspirante, ix);
                }
            } else {
                await this.checkAltaData(aspirante, ix);
            }
        } else {
            let key = aspirante.pasos_preinscrip[i].key;
            if (stepsLabel[i].nombre === 'Subir documentos') {
                if (aspirante.paso_2 === '1') {
                    alertWarning('Los documentos están siendo revisados. Se le notificará cuándo pueda continuar con el proceso');
                } else if (aspirante.paso_2 === '0') {
                    await this.modalStepFunc(stepsLabel[i], aspirante, null, 'medium-modal');
                }
            } else if (stepsLabel[i].nombre === 'Entrevista de ingreso') {
                await this.setState({indicatorButton: true});
                this.checkPayExist(aspirante, i).then(async response => {
                    if (!isNaN(Number(response.reinscripcion.monto)) && Number(response.reinscripcion.monto) !== 0) {
                        this.checkPaymentResult(aspirante, i).then(async res => {
                            await this.setState({indicatorButton: false});
                            if (res.status === 'sin pagar') {
                                await this.modalStepFunc(stepsLabel[i], aspirante, key, 'small-modal');
                            } else if (res.status === 'Rechazado') {
                                await this.modalStepFunc(stepsLabel[i], aspirante, key, 'small-modal');
                            } else if (res.status === 'En progreso') {
                                alertWarning('Su pago está en proceso de ser validado por el administrador, se le notificará cuando pueda continuar con el proceso de inscripción');
                                this._spinner(false);
                            } else if (res.status === 'Completado') {
                                this.foundStep(stepsLabel[i], aspirante).then(async res => {
                                    if (res === 'definido') {
                                        this.saveDateAspIED(aspirante, stepsLabel[i].key).then(async rs => {
                                            if (rs.exist === 'si') {
                                                await this.modalStepFunc(stepsLabel[i], aspirante, null, 'medium-modal');
                                            } else {
                                                await this.alertDefinido(stepsLabel[i], aspirante);
                                            }
                                        });
                                    } else {
                                        this.saveDateAspIED(aspirante, stepsLabel[i].key).then(async rs => {
                                            if (rs.exist === 'si') {
                                                await this.modalStepFunc(stepsLabel[i], aspirante, null, 'medium-modal');
                                            } else {
                                                await this.modalStepFunc(stepsLabel[i], aspirante, null, 'small-modal');
                                            }
                                        });
                                    }
                                })
                            }
                        });
                    } else {
                        await this.setState({indicatorButton: false});
                        this.foundStep(stepsLabel[i], aspirante).then(async res => {
                            if (res === 'definido') {
                                this.saveDateAspIED(aspirante, stepsLabel[i].key).then(async rs => {
                                    if (rs.exist === 'si') {
                                        await this.modalStepFunc(stepsLabel[i], aspirante, null, 'medium-modal');
                                    } else {
                                        await this.alertDefinido(stepsLabel[i], aspirante);
                                    }
                                });
                            } else {
                                this.saveDateAspIED(aspirante, stepsLabel[i].key).then(async rs => {
                                    if (rs.exist === 'si') {
                                        await this.modalStepFunc(stepsLabel[i], aspirante, null, 'medium-modal');
                                    } else {
                                        await this.modalStepFunc(stepsLabel[i], aspirante, null, 'small-modal');
                                    }
                                });
                            }
                        })
                    }
                });
            } else if (stepsLabel[i].nombre === 'Acreditar preinscripción') {
                if (aspirante.paso_4 === '0') {
                    await this.modalStepFunc(stepsLabel[i], aspirante, 'preinscripcion', 'small-modal');
                } else if (aspirante.paso_4 === '1') {
                    await this.revisarPago(aspirante, 'preinscripcion', ix);
                }
            } else if (stepsLabel[i].nombre === 'Día de inmersión') {
                await this.setState({indicatorButton: true});
                this.checkPayExist(aspirante, i).then(async response => {
                    if (!isNaN(Number(response.reinscripcion.monto)) && Number(response.reinscripcion.monto) !== 0) {
                        this.checkPaymentResult(aspirante, i).then(async res => {
                            await this.setState({indicatorButton: false});
                            if (res.status === 'sin pagar') {
                                await this.modalStepFunc(stepsLabel[i], aspirante, key, 'small-modal');
                            } else if (res.status === 'Rechazado') {
                                await this.modalStepFunc(stepsLabel[i], aspirante, key, 'small-modal');
                            } else if (res.status === 'En progreso') {
                                alertWarning('Su pago está en proceso de ser validado por el administrador, se le notificará cuando pueda continuar con el proceso de inscripción');
                                this._spinner(false);
                            } else if (res.status === 'Completado') {
                                this.foundStep(stepsLabel[i], aspirante).then(async res => {
                                    if (res === 'definido') {
                                        this.saveDateAspIED(aspirante, stepsLabel[i].key).then(async rs => {
                                            if (rs.exist === 'si') {
                                                await this.modalStepFunc(stepsLabel[i], aspirante, null, 'medium-modal');
                                            } else {
                                                await this.alertDefinido(stepsLabel[i], aspirante);
                                            }
                                        });
                                    } else {
                                        this.saveDateAspIED(aspirante, stepsLabel[i].key).then(async rs => {
                                            if (rs.exist === 'si') {
                                                await this.modalStepFunc(stepsLabel[i], aspirante, null, 'medium-modal');
                                            } else {
                                                await this.modalStepFunc(stepsLabel[i], aspirante, null, 'small-modal');
                                            }
                                        });
                                    }
                                })
                            }
                        })
                    } else {
                        await this.setState({indicatorButton: false});
                        this.foundStep(stepsLabel[i], aspirante).then(async res => {
                            if (res === 'definido') {
                                this.saveDateAspIED(aspirante, stepsLabel[i].key).then(async rs => {
                                    if (rs.exist === 'si') {
                                        await this.modalStepFunc(stepsLabel[i], aspirante, null, 'medium-modal');
                                    } else {
                                        await this.alertDefinido(stepsLabel[i], aspirante);
                                    }
                                });
                            } else {
                                this.saveDateAspIED(aspirante, stepsLabel[i].key).then(async rs => {
                                    if (rs.exist === 'si') {
                                        await this.modalStepFunc(stepsLabel[i], aspirante, null, 'medium-modal');
                                    } else {
                                        await this.modalStepFunc(stepsLabel[i], aspirante, null, 'small-modal');
                                    }
                                });
                            }
                        })
                    }
                });
            } else if (stepsLabel[i].nombre === 'Examen diagnóstico') {
                await this.setState({indicatorButton: true});
                this.checkPayExist(aspirante, i).then(async response => {
                    if (!isNaN(Number(response.reinscripcion.monto)) && Number(response.reinscripcion.monto) !== 0) {
                        this.checkPaymentResult(aspirante, i).then(async res => {
                            await this.setState({indicatorButton: false});
                            if (res.status === 'sin pagar') {
                                await this.modalStepFunc(stepsLabel[i], aspirante, key, 'small-modal');
                            } else if (res.status === 'Rechazado') {
                                await this.modalStepFunc(stepsLabel[i], aspirante, key, 'small-modal');
                            } else if (res.status === 'En progreso') {
                                alertWarning('Su pago está en proceso de ser validado por el administrador, se le notificará cuando pueda continuar con el proceso de inscripción');
                                this._spinner(false);
                            } else if (res.status === 'Completado') {
                                this.foundStep(stepsLabel[i], aspirante).then(async res => {
                                    if (res === 'definido') {
                                        this.saveDateAspIED(aspirante, stepsLabel[i].key).then(async rs => {
                                            if (rs.exist === 'si') {
                                                await this.modalStepFunc(stepsLabel[i], aspirante, null, 'medium-modal');
                                            } else {
                                                await this.alertDefinido(stepsLabel[i], aspirante);
                                            }
                                        });
                                    } else {
                                        await this.setState({indicatorButton: false});
                                        this.saveDateAspIED(aspirante, stepsLabel[i].key).then(async rs => {
                                            if (rs.exist === 'si') {
                                                await this.modalStepFunc(stepsLabel[i], aspirante, null, 'medium-modal');
                                            } else {
                                                await this.modalStepFunc(stepsLabel[i], aspirante, null, 'small-modal');
                                            }
                                        });
                                    }
                                })
                            }
                        })
                    } else {
                        await this.setState({indicatorButton: false});
                        this.foundStep(stepsLabel[i], aspirante).then(async res => {
                            if (res === 'definido') {
                                this.saveDateAspIED(aspirante, stepsLabel[i].key).then(async rs => {
                                    if (rs.exist === 'si') {
                                        await this.modalStepFunc(stepsLabel[i], aspirante, null, 'medium-modal');
                                    } else {
                                        await this.alertDefinido(stepsLabel[i], aspirante);
                                    }
                                });
                            } else {
                                this.saveDateAspIED(aspirante, stepsLabel[i].key).then(async rs => {
                                    if (rs.exist === 'si') {
                                        await this.modalStepFunc(stepsLabel[i], aspirante, null, 'medium-modal');
                                    } else {
                                        await this.modalStepFunc(stepsLabel[i], aspirante, null, 'small-modal');
                                    }
                                });
                            }
                        })
                    }
                });
            } else if (stepsLabel[i].nombre === 'Resolución de ingreso') {
                if (aspirante.paso_7 === '0') {
                    alertWarning('La administración escolar deberá tomar una decisión con base en los resultados preliminares del aspirante. Se le notificará cuando se actualice el estatus del proceso.');
                } else if (aspirante.paso_7 === '1') {
                    confirmAlert({
                        customUI: ({onClose}) => {
                            return customAlertResp('¡Atención!',
                                'Para conocer más acerca del estatus de la solicitud del aspirante ' + aspirante.nombre_aspirante + ' acuda a las instalaciones del plantel o comuníquese con la institución', 1,
                                'Enterado', null, null,
                                () => [onClose()]);
                        }
                    });
                }
            } else if (stepsLabel[i].nombre === 'Acreditar inscripción') {
                if (aspirante.paso_8 === '0') {
                    await this.modalStepFunc(stepsLabel[i], aspirante, 'inscripcion', 'small-modal');
                } else if (aspirante.paso_8 === '1') {
                    await this.revisarPago(aspirante, 'inscripcion', ix);
                }
            }
        }
    }

    setMessage = (aspirante, index, number) => {
        const message = 'Hola, requiero ayuda para aclaración de dudas en el proceso de admisión de Kolegia School Manager, estos son mis datos:' +
            '\nEscuela: ' + aspirante.escuela.nombre_escuela +
            '\nNivel: ' + aspirante.nivel_escolar +
            '\nTutor: ' + aspirante.tutor.nombre + ' ' + aspirante.tutor.apellido_paterno + ' ' + aspirante.tutor.apellido_materno +
            '\nAspirante: ' + aspirante.nombre + ' ' + aspirante.apellido_paterno + ' ' + aspirante.apellido_materno +
            '\nEmail: ' + aspirante.tutor.email +
            '\nPaso del proceso: ' + aspirante.pasos_preinscrip[index].alias +
            '\nLa problemática es la siguiente: '
        whatsAppMessage(message, aspirante.escuela.id_pais, number)

    }

    rndAspirantes() {
        let aspirante = [];
        if (this.state.aspirantes.length !== 0) {
            this.state.aspirantes.forEach((it, ix) => {
                let i = this.state.stepIndicator[ix];
                let stepsLabel = it.pasos_preinscrip_web;
                let lastBtn = false;
                let textBtn2 = 'Ir a siguiente paso';
                if (stepsLabel !== undefined) {
                    if (stepsLabel[i] !== undefined) {
                        if (stepsLabel[i].title === 'Subir documentos') {
                            if (it.paso_2 === '0') {
                                textBtn2 = 'Ir a siguiente paso';
                            } else if (it.paso_2 === '1') {
                                textBtn2 = 'Documentos en revisión';
                            }
                        } else if (stepsLabel[i].title === 'Entrevista de ingreso') {
                            if (it.paso_3 === '0') {
                                textBtn2 = 'Ir a siguiente paso';
                            } else if (it.paso_3 === '1') {
                                textBtn2 = 'Entrevista en espera';
                            }
                        } else if (stepsLabel[i].title === 'Acreditar preinscripción') {
                            if (it.paso_4 === '0') {
                                textBtn2 = 'Realizar pago';
                            } else if (it.paso_4 === '1') {
                                textBtn2 = 'Pago en revisión';
                            }
                        } else if (stepsLabel[i].title === 'Día de inmersión') {
                            textBtn2 = 'Ir a siguiente paso';
                        } else if (stepsLabel[i].title === 'Examen diagnóstico') {
                            textBtn2 = 'Ir a siguiente paso';
                        } else if (stepsLabel[i].title === 'Resolución de ingreso') {
                            if (it.paso_7 === '0') {
                                textBtn2 = 'En espera';
                            } else if (it.paso_7 === '1') {
                                lastBtn = true;
                                textBtn2 = 'Más información';
                            }
                        } else if (stepsLabel[i].title === 'Acreditar inscripción') {
                            lastBtn = true;
                            if (it.paso_8 === '0') {
                                textBtn2 = 'Realizar pago';
                            } else if (it.paso_8 === '1') {
                                textBtn2 = 'Pago en revisión';
                            }
                        }
                    } else if (i === stepsLabel.length) {
                        lastBtn = true;
                        textBtn2 = 'Concluir registro';
                    }
                }
                aspirante.push(
                    <Row key={ix + 'aspCard'} style={{
                        margin: 0,
                        padding: 10,
                        border: '0.5px solid',
                        borderRadius: 6,
                        borderColor: 'lightgray',
                        backgroundColor: AppEnv.grayColorOne,
                        marginBottom: 5,
                        width: '110%'
                    }} className="uk-width-1-1 normal_text centerAll">
                        <Modal center={true} open={this.state.modalAspirante[ix]}
                               onClose={() => [(this.state.modalAspirante[ix] = false), this.setState({aux: 0})]}>
                            <Col style={{
                                margin: 0,
                                padding: 15,
                                width: '30vw',
                                backgroundColor: AppEnv.fourthColor
                            }} className='modalWidth normal_text scroll centerAll'>
                                <Row style={{color: AppEnv.thirdColor}}>
                                    Escriba la información:
                                </Row>
                                <textarea className="uk-width-1-1 centerAll uk-input"
                                          placeholder='Si existe cualquier información relevante sobre el aspirante ya sea personal o cualquier diagnóstico médico o psicológico, favor de escribirlo aquí.'
                                          onChange={text => (this.state.elComentario = text.target.value)}
                                          defaultValue={this.state.elComentario} style={{
                                    borderColor: AppEnv.secondColor,
                                    color: AppEnv.fifthColor,
                                    fontSize: '.9rem',
                                    padding: 5,
                                    marginTop: 10,
                                    borderRadius: 6,
                                    height: '10vh',
                                    lineHeight: 1
                                }}/>
                                <Row className="uk-width-1-1 centerH" style={{marginTop: 15}}>
                                    <Row style={{marginTop: 15}} className='centerAll'>

                                        <div style={{
                                            padding: 0,
                                            paddingLeft: 15,
                                            paddingRight: 15,
                                            borderRadius: 10,
                                            border: '1px solid',
                                            borderColor: AppEnv.secondColor,
                                            backgroundColor: AppEnv.fourthColor
                                        }}
                                             onClick={() => [(this.state.modalAspirante[ix] = false), this.setState({aux: 0})]}
                                             className='uk-box-shadow-small uk-button'>
                                            <i className='fas fa-times-circle fa-1x'
                                               style={{color: AppEnv.secondColor, marginRight: 5}}/>
                                            <label className='normal_text'
                                                   style={{color: AppEnv.secondColor}}>Cancelar</label>
                                        </div>
                                    </Row>
                                    &nbsp;
                                    <Row style={{marginTop: 15}} className='centerAll'>
                                        <div style={{
                                            padding: 0,
                                            paddingLeft: 15,
                                            paddingRight: 15,
                                            borderRadius: 10,
                                            border: '1px solid',
                                            borderColor: AppEnv.secondColor,
                                            backgroundColor: AppEnv.secondColor
                                        }}
                                             onClick={() => this.enviarIndicacion(this.state.idAlumno, this.state.elComentario, ix)}
                                             className='uk-box-shadow-small uk-button'>
                                            <i className="fas fa-plus-circle fa-1x"
                                               style={{color: AppEnv.fourthColor, marginRight: 5}}/>
                                            <label className='normal_text'
                                                   style={{color: AppEnv.fourthColor}}>Guardar</label>
                                        </div>
                                    </Row>
                                </Row>
                            </Col>
                        </Modal>
                        <Row className='uk-width-1-1' style={{justifyContent: 'space-between'}}>
                            <Col className="uk-width-1-1">
                                <div style={{textAlign: 'left'}}>Aspirante:</div>
                                <div style={{
                                    textAlign: 'left',
                                    fontWeight: '600'
                                }}>{it.nombre_aspirante.toUpperCase()}</div>
                            </Col>
                        </Row>
                        {it.nivel_escolar === 'PREESCOLAR' ? null :
                            <div style={{marginTop: 5, textAlign: 'left'}}
                                 className="uk-width-1-1">Colegio de
                                procedencia: </div>}
                        {it.nivel_escolar === 'PREESCOLAR' ? null :
                            it.escuela_procedente !== null ?
                                <div className="uk-width-1-1" style={{
                                    margin: 0,
                                    padding: 0,
                                    textAlign: 'left',
                                    fontWeight: '600'
                                }}>{it.escuela_procedente.toUpperCase()}</div> : null}
                        <Row style={{marginTop: 5, textAlign: 'left'}} className="uk-width-1-1">Nivel
                            al que aplica: <div
                                style={{fontWeight: '600'}}>&nbsp;{it.escuela.conjunto_uno.toUpperCase()}</div></Row>
                        <Row style={{marginTop: 5, textAlign: 'left'}} className="uk-width-1-1">Grado
                            al que
                            aplica: <div style={{fontWeight: '600'}}>&nbsp;{it.grado_interes}</div></Row>
                        {it.nivel_escolar === 'PREESCOLAR' ? null
                            : it.nivel_escolar === 'PRIMARIA' && it.grado_interes !== '1' ?
                                <Row style={{marginTop: 5, textAlign: 'left'}}
                                     className="uk-width-1-1">Ultimo promedio general: <div
                                    style={{fontWeight: '600'}}>&nbsp;{it.promedio_gral}</div>
                                </Row> : null}
                        <div style={{alignItems: 'center', marginTop: 10}}>
                            {it.paso_4 === '0' && this.state.elComprobante.validar_doc !== undefined && this.state.elComprobante.validar_doc !== '0' && this.state.elComprobante.validar_doc !== '2'
                                ? <div style={{color: AppEnv.redColor, textAlign: 'center'}}>Su comprobante ha sido
                                    rechazado,{'\n'}presione en "Realizar pago" para subirlo de nuevo.</div> : null}
                            {it.paso_8 === '0' && this.state.elComprobante2.validar_doc !== undefined && this.state.elComprobante2.validar_doc !== '0' && this.state.elComprobante2.validar_doc !== '2'
                                ? <div style={{color: AppEnv.redColor, textAlign: 'center'}}>Su
                                    comprobante ha sido rechazado,{'\n'}presione en "Realizar pago" para subirlo de
                                    nuevo.</div> : null}
                        </div>

                        {this.state.soporteKolegiaCheck === '1'||this.state.soporteEscuelaCheck === '1'
                            ?<Row className="uk-width-1-1 centerAll normal_text"
                              style={{
                                  margin: '10px 0 0 0',
                                  padding: 5,
                                  border: '1px solid',
                                  borderColor: AppEnv.grayColorThree,
                                  borderRadius: 6,
                                  backgroundColor: AppEnv.fourthColor
                              }}
                        >
                            <Col className="uk-width-1-3">
                                <Row className="uk-width-1-1 centerAll normal_text">
                                    Necesito ayuda:
                                </Row>
                            </Col>
                            <Col className="uk-width-2-3">
                                <Row className="uk-width-1-1 centerAll normal_text">

                                    {this.state.soporteKolegiaCheck === '1' ?
                                        <Row className="uk-width-1-2 centerAll normal_text"
                                             style={{margin: 0, padding: 2}}>
                                            <KolegiaWhatsAppButton
                                                it={it} i={i}
                                                setMessage={this.setMessage}
                                                kolegia={true}/>
                                        </Row>
                                        : null}
                                    {this.state.soporteEscuelaCheck === '1' ?
                                        <Row className="uk-width-1-2 centerAll normal_text"
                                             style={{margin: 0, padding: 2}}>
                                            <ColegioWhatsAppButton
                                                token={this.state.token} it={it} i={i}
                                                icono={'https://galeriasce.s3-us-west-2.amazonaws.com/img-repos/' + it.bd_escuela + '/icono.png'}
                                                setMessage={this.setMessage} kolegia={false}/>
                                        </Row>
                                        : null}
                                </Row>
                            </Col>
                        </Row>:null}
                        {this.state.indicator ?
                            <Row className="uk-width-1-1 centerAll"
                                 style={{alignItems: 'center', width: '80vw', height: '9vh'}}>
                                {pulseLoader()}
                            </Row>
                            : it.estatus_alta === 'espera' ? null :
                                <CurrentStepCard steps={it.pasos_preinscrip} i={i} alumno={it}/>}
                        <Row className="uk-width-1-1 centerAll"
                             style={{alignItems: 'center'}}>

                            {it.estatus_alta !== 'espera' ?
                                <Row className="uk-width-1-1 centerAll" style={{marginTop: 10}}>
                                    {lastBtn === false
                                        ? <Col className="uk-width-1-2" style={{margin: 0, padding: 5}}>
                                            <div className="uk-width-1-1" style={{
                                                margin: 0,
                                                padding: 8,
                                                borderRadius: 6,
                                                border: '1px solid',
                                                borderColor: AppEnv.secondColor,
                                                backgroundColor: AppEnv.fourthColor,
                                                color: AppEnv.secondColor,
                                                cursor: 'pointer'
                                            }} onClick={() => this.openModal(this.state.aspirantes[ix], ix)}>
                                                Indicaciones especiales
                                            </div>
                                        </Col> : null}
                                    <Col className="uk-width-1-2" style={{margin: 0, padding: 5}}>
                                        {this.state.indicatorButton ? <div className="uk-width-1-1" style={{
                                            margin: 0,
                                            padding: 8,
                                            borderRadius: 6,
                                            border: '1px solid',
                                            borderColor: AppEnv.secondColor,
                                            backgroundColor: AppEnv.secondColor,
                                            color: AppEnv.fourthColor,
                                        }}>
                                            <Row className="uk-width-1-1 centerAll">
                                                {pulseLoader(AppEnv.fourthColor)}
                                            </Row>
                                        </div> : <div className="uk-width-1-1" style={{
                                            margin: 0,
                                            padding: 8,
                                            borderRadius: 6,
                                            border: '1px solid',
                                            borderColor: AppEnv.secondColor,
                                            backgroundColor: AppEnv.secondColor,
                                            color: AppEnv.fourthColor,
                                            cursor: 'pointer',
                                            pointerEvents: false
                                        }} onClick={() => this.pasoSiguiente(it, ix)}>
                                            {this.state.isLoading ? pulseLoader(AppEnv.fourthColor) : textBtn2}
                                        </div>}
                                    </Col>
                                </Row> : <EspereButton/>}
                        </Row>
                        <Row className="uk-width-1-1" style={{justifyContent: 'flex-end'}}>
                            {i === 1 && it.circular_informativa !== '' ?
                                <Row className="centerAll" style={{width: '14.2857143%', margin: 0, padding: 5}}>
                                    <Row
                                        className="uk-width-1-1 centerAll"
                                        data-uk-tooltip="Ver documento informativo"
                                        style={{
                                            margin: 0,
                                            padding: 10,
                                            borderRadius: 6,
                                            backgroundColor: AppEnv.fourthColor,
                                        }}
                                        onClick={() => this.setState({
                                            openPdf: true,
                                            elPdf: it.circular_informativa
                                        })}
                                    >
                                        <Row style={{
                                            margin: 0,
                                            padding: 0,
                                            width: '100%',
                                            color: 'gray',
                                            justifyContent: 'center'
                                        }}>
                                            <i className="fas fa-file-pdf" style={{fontSize: '1.2rem'}}/>
                                        </Row>
                                        <Row className="uk-width-1-1" style={{
                                            margin: 0,
                                            padding: 0,
                                            textAlign: 'center',
                                            marginTop: 7
                                        }}>
                                            <div className="uk-width-1-1 uk-text-truncate" style={{color: 'gray'}}>Ver
                                                documento informativo
                                            </div>
                                        </Row>
                                    </Row>
                                </Row> : null}
                            {i === 1 && it.ficha_solicitud !== '' ?
                                <Row className="centerAll" style={{width: '14.2857143%', margin: 0, padding: 5}}>
                                    <Row
                                        className="uk-width-1-1 centerAll"
                                        data-uk-tooltip="Ver ficha de solicitud"
                                        style={{
                                            margin: 0,
                                            padding: 10,
                                            borderRadius: 6,
                                            backgroundColor: AppEnv.fourthColor,
                                        }}
                                        onClick={() => this.setState({
                                            openPdf: true,
                                            elPdf: it.ficha_solicitud
                                        })}
                                    >
                                        <Row style={{
                                            margin: 0,
                                            padding: 0,
                                            width: '100%',
                                            color: 'gray',
                                            justifyContent: 'center'
                                        }}>
                                            <i className="fas fa-file-pdf" style={{fontSize: '1.2rem'}}/>
                                        </Row>
                                        <Row className="uk-width-1-1" style={{
                                            margin: 0,
                                            padding: 0,
                                            textAlign: 'center',
                                            marginTop: 7
                                        }}>
                                            <div className="uk-width-1-1 uk-text-truncate" style={{color: 'gray'}}>Ver
                                                ficha de solicitud
                                            </div>
                                        </Row>
                                    </Row>
                                </Row> : null}
                            {i === 1 && it.otro_solicitud !== '' ?
                                <Row className="centerAll" style={{width: '14.2857143%', margin: 0, padding: 5}}>
                                    <Row
                                        data-uk-tooltip="Cuestionario de entrevista"
                                        className="uk-width-1-1 centerAll"
                                        style={{
                                            margin: 0,
                                            padding: 10,
                                            borderRadius: 6,
                                            backgroundColor: AppEnv.fourthColor,
                                        }}
                                        onClick={() => this.setState({
                                            openPdf: true,
                                            elPdf: it.otro_solicitud
                                        })}
                                    >
                                        <Row style={{
                                            margin: 0,
                                            padding: 0,
                                            width: '100%',
                                            color: 'gray',
                                            justifyContent: 'center'
                                        }}>
                                            <i className="fas fa-file-pdf" style={{fontSize: '1.2rem'}}/>
                                        </Row>
                                        <Row className="uk-width-1-1" style={{
                                            margin: 0,
                                            padding: 0,
                                            textAlign: 'center',
                                            marginTop: 7
                                        }}>
                                            <div className="uk-width-1-1 uk-text-truncate"
                                                 style={{color: 'gray'}}>Cuestionario de entrevista
                                            </div>
                                        </Row>
                                    </Row>
                                </Row> : null}
                            {i === 1 && it.acuerdo_convivencia !== '' ?
                                <Row className="centerAll" style={{width: '14.2857143%', margin: 0, padding: 5}}>
                                    <Row
                                        className="uk-width-1-1 centerAll"
                                        data-uk-tooltip="Acuerdo de convivencia"
                                        style={{
                                            margin: 0,
                                            padding: 10,
                                            borderRadius: 6,
                                            backgroundColor: AppEnv.fourthColor,
                                        }}
                                        onClick={() => this.setState({
                                            openPdf: true,
                                            elPdf: it.acuerdo_convivencia
                                        })}
                                    >
                                        <Row style={{
                                            margin: 0,
                                            padding: 0,
                                            width: '100%',
                                            color: 'gray',
                                            justifyContent: 'center'
                                        }}>
                                            <i className="fas fa-file-pdf" style={{fontSize: '1.2rem'}}/>
                                        </Row>
                                        <Row className="uk-width-1-1" style={{
                                            margin: 0,
                                            padding: 0,
                                            textAlign: 'center',
                                            marginTop: 7
                                        }}>
                                            <div className="uk-width-1-1 uk-text-truncate"
                                                 style={{color: 'gray'}}>Acuerdo de convivencia
                                            </div>
                                        </Row>
                                    </Row>
                                </Row> : null}
                            {i === 1 && it.contrato_servicio !== '' ?
                                <Row className="centerAll" style={{width: '14.2857143%', margin: 0, padding: 5}}>
                                    <Row
                                        className="uk-width-1-1 centerAll"
                                        data-uk-tooltip="Contrato de servicio"
                                        style={{
                                            margin: 0,
                                            padding: 10,
                                            borderRadius: 6,
                                            backgroundColor: AppEnv.fourthColor,
                                        }}
                                        onClick={() => this.setState({
                                            openPdf: true,
                                            elPdf: it.contrato_servicio
                                        })}
                                    >
                                        <Row style={{
                                            margin: 0,
                                            padding: 0,
                                            width: '100%',
                                            color: 'gray',
                                            justifyContent: 'center'
                                        }}>
                                            <i className="fas fa-file-pdf" style={{fontSize: '1.2rem'}}/>
                                        </Row>
                                        <Row className="uk-width-1-1" style={{
                                            margin: 0,
                                            padding: 0,
                                            textAlign: 'center',
                                            marginTop: 7
                                        }}>
                                            <div className="uk-width-1-1 uk-text-truncate"
                                                 style={{color: 'gray'}}>Contrato de servicio
                                            </div>
                                        </Row>
                                    </Row>
                                </Row> : null}
                            {i === 1 && it.aviso_privacidad !== '' ?
                                <Row className="centerAll" style={{width: '14.2857143%', margin: 0, padding: 5}}>
                                    <Row
                                        className="uk-width-1-1 centerAll"
                                        data-uk-tooltip="Aviso de privacidad"
                                        style={{
                                            margin: 0,
                                            padding: 10,
                                            borderRadius: 6,
                                            backgroundColor: AppEnv.fourthColor,
                                        }}
                                        onClick={() => this.setState({
                                            openPdf: true,
                                            elPdf: it.aviso_privacidad
                                        })}
                                    >
                                        <Row style={{
                                            margin: 0,
                                            padding: 0,
                                            width: '100%',
                                            color: 'gray',
                                            justifyContent: 'center'
                                        }}>
                                            <i className="fas fa-file-pdf" style={{fontSize: '1.2rem'}}/>
                                        </Row>
                                        <Row className="uk-width-1-1" style={{
                                            margin: 0,
                                            padding: 0,
                                            textAlign: 'center',
                                            marginTop: 7
                                        }}>
                                            <div className="uk-width-1-1 uk-text-truncate"
                                                 style={{color: 'gray'}}>Contrato de servicio
                                            </div>
                                        </Row>
                                    </Row>
                                </Row> : null}
                            {i === 1 && it.carta_compromiso !== '' ?
                                <Row className="centerAll" style={{width: '14.2857143%', margin: 0, padding: 5}}>
                                    <Row
                                        className="uk-width-1-1 centerAll"
                                        data-uk-tooltip="Corresponsabilidad"
                                        style={{
                                            margin: 0,
                                            padding: 10,
                                            borderRadius: 6,
                                            backgroundColor: AppEnv.fourthColor,
                                        }}
                                        onClick={() => this.setState({
                                            openPdf: true,
                                            elPdf: it.carta_compromiso
                                        })}
                                    >
                                        <Row style={{
                                            margin: 0,
                                            padding: 0,
                                            width: '100%',
                                            color: 'gray',
                                            justifyContent: 'center'
                                        }}>
                                            <i className="fas fa-file-pdf" style={{fontSize: '1.2rem'}}/>
                                        </Row>
                                        <Row className="uk-width-1-1" style={{
                                            margin: 0,
                                            padding: 0,
                                            textAlign: 'center',
                                            marginTop: 7
                                        }}>
                                            <div className="uk-width-1-1 uk-text-truncate"
                                                 style={{color: 'gray'}}>Corresponsabilidad
                                            </div>
                                        </Row>
                                    </Row>
                                </Row> : null}
                            {stepsLabel !== undefined && stepsLabel[i] !== undefined && stepsLabel[i].title === 'Entrevista de ingreso' && it.ficha_entrevista !== '' ?
                                <Row className="centerAll" style={{width: '14.2857143%', margin: 0, padding: 5}}>
                                    <Row
                                        className="uk-width-1-1 centerAll"
                                        data-uk-tooltip="Ver documento de entrevista"
                                        style={{
                                            margin: 0,
                                            padding: 10,
                                            marginTop: 0,
                                            borderRadius: 6,
                                            backgroundColor: AppEnv.fourthColor,
                                        }}
                                        onClick={() => this.setState({
                                            openPdf: true,
                                            elPdf: it.ficha_entrevista
                                        })}
                                    >
                                        <Row style={{
                                            margin: 0,
                                            padding: 0,
                                            width: '100%',
                                            color: 'gray',
                                            justifyContent: 'center'
                                        }}>
                                            <i className="fas fa-file-pdf" style={{fontSize: '1.2rem'}}/>
                                        </Row>
                                        <Row style={{
                                            margin: 0,
                                            padding: 0,
                                            width: '100%',
                                            textAlign: 'center',
                                            marginTop: 7
                                        }}>
                                            <div className="uk-width-1-1 uk-text-truncate" style={{color: 'gray'}}>
                                                Ver documento de entrevista
                                            </div>
                                        </Row>
                                    </Row>
                                </Row> : null}
                            <Row className="uk-width-1-1">
                                <AvailabilityWarning steps={it.pasos_preinscrip} i={i} alumno={it}/>
                            </Row>
                        </Row>
                    </Row>
                );
            });
        }
        return aspirante;
    }

    async onPressModal(state) {
        await this.setState({modalSteps: state});
    }

    async addNewAsp() {
        if (AppEnv.tipoApp === '1') {
            confirmAlert({
                customUI: ({onClose}) => {
                    return customAlertResp('Nuevo aspirante',
                        'Esta a punto de agregar un nuevo aspirante, ¿Seguro que desea continuar?', 2,
                        'Sí', 'No', null,
                        () => [onClose()], () => [onClose()]);
                }
            });
        } else {
            confirmAlert({
                customUI: ({onClose}) => {
                    return customAlertResp('Nuevo aspirante',
                        'Esta a punto de agregar un nuevo aspirante, ¿Seguro que desea continuar?', 2,
                        'Sí', 'No', null,
                        () => [onClose()], () => [onClose()]);
                }
            });
        }
        await this.setState({modalNewAsp: true});
    }

    async refreshAspirantes() {
        await this.getAspirantes(this.state.idTutor);
    }

    render() {
        return (
            <Row className="uk-width-1-1 centerAll">
                <ModalSteps extraData={'padre'} stepModal={this.state.modalSteps} elPaso={this.state.elPaso}
                            sizeModal={this.state.sizeModal}
                            data1={this.state.data1}
                            data2={this.state.data2} onPressModal={() => this.onPressModal(false)}/>
                <Modal
                    center={true}
                    open={this.state.modalPago}
                    onClose={() => [(this.state.modalPago = false), this.setState({aux: 0})]}
                >
                    <Col style={{
                        margin: 0,
                        padding: 15,
                        backgroundColor: AppEnv.fourthColor
                    }} className='modalWidth normal_text scroll centerAll'>
                        {this.state.selItem.amount !== undefined ?
                            <Col className='uk-width-1-1' style={{marginTop: '1vh'}}>
                                <Row className='uk-width-1-1 sub_title'
                                     style={{marginTop: '1vh'}}>
                                    Información para realizar el pago
                                </Row>
                                <div className='uk-width-1-1 section_title_two'
                                     style={{textAlign: 'left'}}>
                                    Su pago está siendo procesado. Éste será reflejado en un lapso de 24 a 48 horas
                                    después de haber sido pagado
                                </div>
                                <Row className='uk-width-1-1'>
                                    <Col className='uk-width-1-1' style={{margin: 0, padding: 5}}>
                                        <Col className='uk-width-1-1' style={{
                                            margin: 0,
                                            padding: 10,
                                            backgroundColor: AppEnv.grayColorTwo,
                                            borderRadius: 6
                                        }}>
                                            <Row className="normal_text uk-width-1-1@s"
                                                 style={{marginVertical: 2}}>
                                                Desde BBVA
                                            </Row>
                                            <Row className="normal_text uk-width-1-1@s"
                                                 style={{marginVertical: 2}}>
                                                Número de convenio CIE:
                                                <div style={{
                                                    fontWeight: '600',
                                                    marginLeft: 4
                                                }}>
                                                    {this.state.selItem.payment_method.agreement}
                                                </div>
                                            </Row>
                                            <Row className="normal_text uk-width-1-1@s"
                                                 style={{marginVertical: 2}}>
                                                Referencia:
                                                <div style={{
                                                    fontWeight: '600',
                                                    marginLeft: 4
                                                }}>
                                                    {this.state.selItem.payment_method.name}
                                                </div>
                                            </Row>
                                            <Row className="normal_text uk-width-1-1@s"
                                                 style={{marginVertical: 2}}>
                                                Importe:
                                                <div style={{
                                                    fontWeight: '600',
                                                    marginLeft: 4
                                                }}>
                                                    {currency(this.state.selItem.amount)}
                                                </div>
                                            </Row>
                                            <Row className="normal_text uk-width-1-1@s" style={{
                                                margin: 0,
                                                padding: 0,
                                                textAlign: 'left',
                                                marginVertical: 2
                                            }}>
                                                Concepto:
                                                <div style={{
                                                    fontWeight: '600',
                                                    marginLeft: 4
                                                }}>
                                                    {this.state.selItem.description}
                                                </div>
                                            </Row>
                                        </Col>
                                    </Col>
                                    <Col className='uk-width-1-1' style={{
                                        margin: 0,
                                        padding: 5
                                    }}>
                                        <Col className='uk-width-1-1' style={{
                                            margin: 0,
                                            padding: 10,
                                            backgroundColor: AppEnv.grayColorTwo,
                                            borderRadius: 6
                                        }}>
                                            <Row className="normal_text uk-width-1-1@s"
                                                 style={{marginVertical: 2}}>
                                                Desde cualquier otro banco
                                            </Row>
                                            <Row className="normal_text uk-width-1-1@s"
                                                 style={{marginVertical: 2}}>
                                                Banco destino:
                                                <div style={{
                                                    fontWeight: '600',
                                                    marginLeft: 4
                                                }}>
                                                    {this.state.selItem.payment_method.bank}
                                                </div>
                                            </Row>
                                            <Row className="normal_text uk-width-1-1@s"
                                                 style={{marginVertical: 2}}>
                                                Clabe:
                                                <div style={{
                                                    fontWeight: '600',
                                                    marginLeft: 4
                                                }}>
                                                    {this.state.selItem.payment_method.clabe}
                                                </div>
                                            </Row>
                                            <Row className="normal_text uk-width-1-1@s"
                                                 style={{marginVertical: 2}}>
                                                Concepto de pago:
                                                <div style={{
                                                    fontWeight: '600',
                                                    marginLeft: 4
                                                }}>
                                                    {this.state.selItem.payment_method.name}
                                                </div>
                                            </Row>
                                            <Row className="normal_text uk-width-1-1@s"
                                                 style={{marginVertical: 2}}>
                                                Referencia:
                                                <div style={{
                                                    fontWeight: '600',
                                                    marginLeft: 4
                                                }}>
                                                    {this.state.selItem.payment_method.agreement}
                                                </div>
                                            </Row>
                                            <Row className="normal_text uk-width-1-1@s"
                                                 style={{marginVertical: 2}}>
                                                Importe:
                                                <div style={{
                                                    fontWeight: '600',
                                                    marginLeft: 4
                                                }}>
                                                    {currency(this.state.selItem.amount)}
                                                </div>
                                            </Row>
                                        </Col>
                                    </Col>
                                </Row>
                            </Col> : null}
                        <Row className="uk-width-1-1@s centerAll">
                            <Col style={{padding: 5, margin: 0}} className="centerAll uk-width-1-3@s">
                                <div className='uk-width-1-1@s' style={{
                                    margin: 0,
                                    padding: 7,
                                    lineHeight: 1,
                                    backgroundColor: AppEnv.secondColor,
                                    borderRadius: 7
                                }} onClick={() => this.setState({documento: !this.state.documento})}>
                                    <Row className='uk-width-1-1'>
                                        <label className='normal_text uk-width-1-1'
                                               style={{color: 'white', lineHeight: 1}}>
                                            Ver PDF
                                        </label>
                                    </Row>
                                </div>
                            </Col>
                            <Modal center open={this.state.documento}
                                   onClose={() => this.setState({documento: false})}>
                                <Row style={{margin: 0, padding: 10}} className='modalWidth1'>
                                    <iframe title="video 1" className='uk-width-1-1'
                                            style={{marginTop: 10, height: '80vh'}}
                                            src={this.state.production
                                                ? 'https://dashboard.openpay.mx/spei-pdf/' + this.state.op + '/' + this.state.elPdf
                                                : 'https://sandbox-dashboard.openpay.mx/spei-pdf/' + this.state.op + '/' + this.state.elPdf}/>
                                </Row>
                            </Modal>
                        </Row>
                    </Col>
                </Modal>
                <Modal
                    closeOnOverlayClick={false}
                    center={true}
                    open={this.state.modalPassword}
                    showCloseIcon={false}
                    onClose={() => console.info('nada')}
                >
                    <Row style={{
                        margin: 0,
                        padding: 15,
                        backgroundColor: AppEnv.fourthColor
                    }} className='modalWidth normal_text centerAll'>
                        <PasswordCheck f={(password) => this.validationDatos(password)} title={'Definir contraseña'}
                                       textButton={'Definir contraseña'}/>
                    </Row>
                </Modal>
                <Modal open={this.state.openPdf}
                       onClose={() => [(this.state.openPdf = false), this.setState({aux: 0})]} center>
                    <Col style={{
                        margin: 0,
                        padding: 15,
                        height: '70vh',
                        backgroundColor: AppEnv.fourthColor
                    }} className='modalWidth centerAll normal_text'>
                        <iframe title="video 2"
                                className='uk-width-1-1'
                                style={{height: '70vh'}}
                                src={this.state.elPdf}
                        />
                    </Col>
                </Modal>
                <Row className="uk-width-1-1" style={{justifyContent: 'flex-end'}}>
                    <Row
                        className="uk-width-1-6 centerAll"
                        style={{
                            padding: 5,
                            margin: 0,
                            marginBottom: 5,
                            marginTop: -20,
                            borderRadius: 6,
                            backgroundColor: AppEnv.secondColor,
                            width: '12%',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                        onClick={() => this.refreshAspirantes()}
                    >
                        <i className="fas fa-sync-alt"
                           style={{fontSize: '1rem', color: AppEnv.fourthColor}}/>
                    </Row>
                </Row>
                <Row style={{marginTop: 10}} className='uk-width-1-1 main_title'>
                    Datos de los aspirantes
                </Row>
                {this.state.aspirantes.length !== 0 ? this.rndAspirantes() :
                    <FaltaMensaje falta={'No tiene aspirantes con proceso de admisión activo'}/>}
            </Row>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        countries: state.gestion.countries,
        country: state.gestion.country
    };
};

export default connect(mapStateToProps, {setInitValues})(AspirantesTutor);

const KolegiaWhatsAppButton = ({it, i, setMessage}) => {
    return (
        <Row onClick={() => setMessage(it, i, AppEnv.celular_soporte)} className="uk-width-1-1 centerAll" style={{
            backgroundColor: AppEnv.kolegiaBlue,
            borderRadius: 6,
            padding: 4,
            cursor: 'pointer',
            margin: 0
        }}>
            <Row className={'uk-width-1-1 centerAll'}>
                <div className={'uk-width-1-3'}>
                    <img alt="" src={'/images/imagogris.png'} width='20px'/>
                </div>
                <div className={'uk-width-2-3 centerAll'} style={{fontSize: '1em', color: AppEnv.fourthColor}}>
                    Soporte
                </div>
            </Row>
        </Row>
    )
}

const ColegioWhatsAppButton = ({icono, it, i, setMessage}) => {
    const [number, setNumber] = React.useState('')
    React.useEffect(() => {
        getEscuelaNumber()
    }) // eslint-disable-line react-hooks/exhaustive-deps

    const getEscuelaNumber = async () => {
        const config = {headers: {'Content-Type': 'application/json'}}
        const {data} = await axios.get(AppEnv.api + it.bd_escuela + '/config/all', config)
        setNumber(data.number_whatsapp)
    }

    return (
        <Row onClick={() => setMessage(it, i, number)} className="uk-width-1-1 centerAll" style={{
            border: '1px solid ' + AppEnv.greenColor,
            background: AppEnv.fourthColor,
            borderRadius: 6,
            padding: 4,
            cursor: 'pointer',
            margin: 0,
        }}>
            <Row className={'uk-width-1-1 centerAll'}>
                <div className={'uk-width-1-3'}>
                    <img alt="" src={icono} width='20px'/>
                </div>
                <div className={'uk-width-2-3 centerAll'} style={{fontSize: '1em', color: AppEnv.fifthColor,}}>
                    Soporte
                </div>
            </Row>
        </Row>
    )
}

const EspereButton = () => {
    const message = 'En este momento aún no hay lugares disponibles. Manténgase en contacto en caso que se libere algún lugar.'

    return (
        <div className="uk-width-1-1" style={{
            margin: '20px 0 0 0',
            padding: 8,
            borderRadius: 6,
            border: '1px solid',
            borderColor: AppEnv.secondColor,
            backgroundColor: AppEnv.secondColor,
            color: AppEnv.fourthColor,
            cursor: 'pointer',
            pointerEvents: false,
            fontSize: '1.1rem'
        }} onClick={() => confirmAlert({
            customUI: ({onClose}) => {
                return customAlert('En lista de espera',
                    message, 1,
                    'Enterado, gracias', null, null,
                    () => {
                        onClose()
                    }, null);
            }
        })}>
            En lista de espera
        </div>
    )
}

const CurrentStepCard = ({steps, i, alumno}) => {

    const stepStatusLabel = (status) => {
        let label
        switch (status) {
            case 0:
                label = 'Pendiente'
                break
            case 1:
                label = 'En espera de revisión'
                break
            case 2:
                label = 'Concluído'
                break
            default:
                label = 'Pendiente'
        }
        return label
    }

    const stepStatusColor = (status) => {
        let color
        switch (status) {
            case 0:
                color = 'rgb(251, 140, 0)'
                break
            case 1:
                color = 'rgb(255, 235, 59)'
                break
            case 2:
                color = 'rgb(67, 213, 81)'
                break
            default:
                color = 'rgb(251, 140, 0)'
        }
        return color
    }

    return (
        <Row className="uk-width-1-1 centerAll"
             style={{margin: '0 0 0 0', padding: 0}}>
            <Col className="uk-width-1-1 centerAll" style={{
                margin: 0,
                marginTop: 10,
                borderRadius: 6,
                padding: 0,
                border: '1px solid',
                backgroundColor: AppEnv.fourthColor,
                borderColor: 'lightgray',
                overflow: 'hidden',
                boxSizing: 'border-box'
            }}>
                <Row className="uk-width-1-1">
                    <Row className="uk-width-1-5"
                         style={{
                             margin: 0,
                             alignItems: 'center',
                             height: '58px'
                         }}>
                        <Col className="uk-width-1-1 centerAll" style={{
                            margin: 0,
                            padding: 5,
                            height: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            flexDirection: 'column'
                        }}>
                            <Row className="uk-width-1-1 centerAll" style={{flex: 10}}>
                                <div className='blob' style={{background: stepStatusColor()}}
                                     data-uk-tooltip={stepStatusLabel(alumno['paso_' + (i + 1)])}/>
                            </Row>
                            <Row className="uk-width-1-1 centerAll" style={{flex: 1}}>
                                {stepStatusLabel(alumno['paso_' + (i + 1)])}
                            </Row>
                        </Col>
                    </Row>
                    <Col className="uk-width-3-5 centerH"
                         style={{margin: 0, padding: 5, height: '100%', display: 'flex', flexDirection: 'column'}}>

                        {i === steps.length ?
                            <Row className="uk-width-1-1">
                                <Row className="uk-width-1-1"
                                     style={{color: '#292929', fontSize: '15px'}}>
                                    PASO FINAL
                                </Row>
                                <Row className="uk-width-1-1 module_title"
                                     style={{fontSize: '23px'}}>
                                    DARSE DE ALTA
                                </Row>
                            </Row>
                            : <Row className="uk-width-1-1">
                                <Row className="uk-width-1-1"
                                     style={{color: '#292929', fontSize: '15px'}}>
                                    PASO {i + 1} DE {steps.length}
                                </Row>
                                <Row className="uk-width-1-1 module_title uk-text-truncate"
                                     data-uk-tooltip={steps[i].alias}
                                     style={{fontSize: '21px', textTransform:'uppercase'}}>
                                    {steps[i].alias}
                                </Row>
                            </Row>}
                    </Col>
                    <div className="uk-width-1-5">
                        <Quota alumno={alumno} i={i}/>
                    </div>
                </Row>
            </Col>
        </Row>
    )
}

const AvailabilityWarning = ({alumno}) => {
    const [total, setTotal] = React.useState(1)

    React.useEffect(() => {
        if (alumno.escuelaAspirantes) {
            getStatistics()
        }
    }, [alumno.escuelaAspirantes]) // eslint-disable-line react-hooks/exhaustive-deps

    const getStatistics = () => {
        if (alumno.grados_limite_status === '1') {
            const result = (Number(Object.entries(JSON.parse(alumno.grados_config)).filter(grado => grado[0] === alumno.grado_interes)[0][1]) - Number(alumno.escuelaAspirantes.filter(aspirante => aspirante.grado_interes === alumno.grado_interes).length))
            setTotal(result)
        }
    }

    return (
        <div className="uk-width-1-1" style={{marginTop: 5, textAlign: 'left'}}>
            {alumno.grados_limite_status && alumno.grados_config ?
                total === 0 ? 'En este momento no hay lugares disponibles, sin embargo, una vez terminado el proceso de admisión, el aspirante entrará en lista de espera debido a que ya no hay espacio disponible en el grado deseado.'
                    : null
                : null}
        </div>
    )
}

const Quota = ({alumno, i}) => {
    const config = {headers: {'Content-Type': 'application/json'}}
    const [gradosConfig, setGradosConfig] = React.useState(null)
    const [aspirantes, setAspirantes] = React.useState([])
    const [gradosLimiteStatus, setGradosLimiteStatus] = React.useState('0')

    React.useEffect(() => {
        getGlobalConfigs()
        getPreinscritos()
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const getGlobalConfigs = async () => {
        try {
            const {data} = await axios.get(AppEnv.api + alumno.bd_escuela + '/config/all', config)
            setGradosConfig(JSON.parse(data.grados_config))
            setGradosLimiteStatus(data.grados_limite_status)
        } catch (error) {
            console.error('error -> ', error)
        }
    }

    const getPreinscritos = async () => {
        try {
            const response = await axios.get(AppEnv.api + alumno.bd_escuela + '/get/ciclo/siguiente')
            const {data} = await axios.get(AppEnv.api + alumno.bd_escuela + '/get/aspirantes/alta/' + response.data.id + '/' + alumno.grado_interes)
            setAspirantes(data)
        } catch (error) {
            console.error('error -> ', error)
        }
    }

    const getStatistics = () => {
        if (gradosLimiteStatus === '0') {

        } else {
            return (Number(Object.entries(gradosConfig).filter(grado => grado[0] === alumno.grado_interes)[0][1]) - Number(aspirantes.filter(aspirante => aspirante.grado_interes === alumno.grado_interes).length)) + '/' + Number(Object.entries(gradosConfig).filter(grado => grado[0] === alumno.grado_interes)[0][1])
        }
    }

    const getColors = () => {
        if (gradosLimiteStatus !== '0') {
            if (gradosConfig !== null) {
                const percentage = (Number(Object.entries(gradosConfig).filter(grado => grado[0] === alumno.grado_interes)[0][1]) - Number(aspirantes.filter(aspirante => aspirante.grado_interes === alumno.grado_interes).length)) * 100 / Number(Object.entries(gradosConfig).filter(grado => grado[0] === alumno.grado_interes)[0][1])
                if (percentage === 0) {
                    return {background: AppEnv.secondColor, color: 'white'}
                } else if (percentage <= 33) {
                    return {background: AppEnv.orangeColorTwo, color: 'white'}
                } else if (percentage <= 66) {
                    return {background: AppEnv.yellowColor, color: 'black'}
                } else {
                    return {background: AppEnv.greenColorTwo, color: 'white'}
                }
            } else {
                return {background: 'white', color: 'black'}
            }
        } else {
            return {background: 'white', color: 'black'}
        }
    }

    return (
        <Row className="uk-width-1-1 centerH" style={{
            margin: 0,
            padding: 5,
            alignItems: 'center',
            backgroundColor: 'white',
            height: '100%',
            color: 'black',
            paddingRight: 10,
            ...getColors()
        }}>
            <div className="uk-width-1-1 centerAll" style={{fontSize: '12px'}} onClick={() => {
                getColors()
            }}>
                {gradosLimiteStatus === '1' ? 'Lugares disponibles' : null}
            </div>
            <div className={"uk-width-1-1"} style={{fontSize: '1.1rem', fontWeight: 600}}
                 onClick={() => getStatistics()}>
                {gradosConfig ? getStatistics() : '0/0'}
            </div>
        </Row>
    )
}
